module.exports = __webpack_public_path__ + "img/gamepad.a638c2f5.png";